import { render, staticRenderFns } from "./tm-accordion.vue?vue&type=template&id=666469f6&scoped=true&"
import script from "./tm-accordion.vue?vue&type=script&lang=ts&"
export * from "./tm-accordion.vue?vue&type=script&lang=ts&"
import style0 from "./tm-accordion.vue?vue&type=style&index=0&id=666469f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666469f6",
  null
  
)

export default component.exports